import React from 'react';
import { connect } from 'react-redux';
import {
  IDispatchProps,
  IProps,
  IState,
} from './interfaces';
import { UiSection } from '../../../../enums';
import { PublishProfilesDialog, VaultIcon } from '../../../Shared';
import { VaultPublishButton } from './styles';
import { clearRenditions, getRenditions } from '../../../../state/selectedAssetRenditions';

class VaultPublishOptions extends React.Component<IProps, IState> {
  private static readonly vaultButtonId = `${UiSection.SearchResults}.Vault`;

  state: Readonly<IState> = {
    isOpen: false,
  };

  toggleDialog = () => {
    const { isOpen } = this.state;
    const { selectedAssets, getRenditions, clearRenditions } = this.props;
    if (!isOpen) {
      // Get renditions for selected assets
      const assetIds = selectedAssets?.map((asset) => asset._id);
      if (assetIds) getRenditions(assetIds);
    } else {
      clearRenditions();
    }
    this.setState({
      isOpen: !isOpen,
    });
  };

  render() {
    const {
      disabled,
      onPublish,
      selectedAssets,
    } = this.props;

    const {
      isOpen,
    } = this.state;

    return (
      <>
        <VaultPublishButton
          variant="primaryOnWhite"
          id={VaultPublishOptions.vaultButtonId}
          data-auto="VaultSocialBtn"
          disabled={disabled}
          onClick={this.toggleDialog}
        >
          <VaultIcon />
        </VaultPublishButton>
        <PublishProfilesDialog
          isDialogOpen={isOpen}
          onPublish={onPublish}
          onClose={this.toggleDialog}
          selectedAssets={selectedAssets}
        />
      </>
    );
  }
}

const mapDispatchToProps: IDispatchProps = {
  getRenditions,
  clearRenditions,
};

export default connect(null, mapDispatchToProps)(VaultPublishOptions);
